import React from "react";
import styled from "styled-components/macro";
import { Skeleton } from "antd";

const SkeletonMenu = styled.nav`
  display: flex;
  flex-wrap: wrap;
  background: white;
  justify-content: center;
  align-items: center;
  height: 48px;
`;

const SkeletonItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 20px;
  * {
    margin: 0 !important;
  }
  animation: fadeIn 0.5s ease;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export default function OpportunitySkeleton() {
  return (
    <SkeletonMenu>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      <SkeletonItem>
        <Skeleton
          active
          avatar={false}
          title={{ width: 80, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
    </SkeletonMenu>
  );
}
